export function appUrl(appName: string, path: string): string {
  if (appName === 'brand') {
    appName = 'brands';
  }
  const url = new URL(window.location.origin);
  switch (url.hostname) {
    case '127.0.0.1':
    case 'localhost': {
      const portMapping = {
        brands: 8802,
        partner: 8804,
        admin: 8801,
        customer: 8805,
        api: 3000,
        payment: 3001,
        rating: 3002,
        'order-intake-forms-backoffice': 3014,
      };
      return `${url.protocol}//${url.hostname}:${portMapping[appName]}${path}`;
    }
    default: {
      let domain = url.hostname.replace(/^[^.]+\./, '');
      if (url.port) {
        domain += ':' + url.port;
      }
      return `${url.protocol}//${appName}.${domain}${path}`;
    }
  }
}
